import { useReveal } from "../../hooks/useReveal2";
import AfricaMap from "../../illustrations/AfricaMap";
import "./AfricaConnect.css";

export default function AfricaConnect() {
  const scopeRef = useReveal();

  return (
    <section id="couverture" className="africa-connect" ref={scopeRef}>
      <div className="africa-connect-container">
        <div className="section-header reveal">
          <p className="eyebrow">🌍 A Growing Network</p>
          <h2 className="section-title">
            Connected Everywhere Around the globe
          </h2>
          <p className="section-subtitle">
            MASOMO connects students across the globe—with the goal of
            connecting students enrolled in the same class everywhere,
            regardless of their geographic location, city by city.
          </p>
        </div>

        <div className="africa-connect-visual reveal reveal-delay-2">
          <AfricaMap />
        </div>
      </div>
    </section>
  );
}
